var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner7({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 35,
    viewBox: "0 0 184 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.179 17.8082C161.236 17.1651 160.207 16.7363 159.178 16.1789C158.534 15.8358 157.848 15.4928 157.291 15.0212C156.348 14.2493 156.519 12.7057 157.548 12.0197C158.963 11.0764 161.321 11.5909 161.579 13.5204C161.579 13.5633 161.622 13.6062 161.665 13.6062H163.808C163.851 13.6062 163.894 13.5633 163.894 13.5204C163.766 12.1912 163.251 11.0764 162.308 10.3474C161.407 9.66138 160.378 9.31836 159.263 9.31836C153.603 9.31836 153.089 15.3213 156.133 17.2079C156.476 17.4223 159.478 18.9231 160.55 19.6091C161.622 20.2523 161.922 21.4529 161.493 22.3962C161.064 23.2537 159.992 23.854 158.92 23.7683C157.72 23.6825 156.819 23.0394 156.476 22.0532C156.433 21.8816 156.39 21.5386 156.39 21.3671C156.39 21.3242 156.348 21.2814 156.305 21.2814H153.989C153.946 21.2814 153.904 21.3242 153.904 21.3671C153.904 23.0394 154.332 23.9827 155.447 24.8402C156.519 25.6549 157.677 25.9979 158.92 25.9979C162.093 25.9979 163.723 24.1971 164.066 22.3533C164.323 20.5524 163.808 18.9231 162.179 17.8082Z",
    fill: "#FFE360"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1152 9.66113H60.0861H58.9713C58.9284 9.66113 58.8855 9.70401 58.8855 9.70401L56.956 16.0071C56.9131 16.0928 56.8274 16.0928 56.7845 16.0071L54.855 9.70401C54.855 9.66113 54.8121 9.66113 54.7692 9.66113H53.6544H52.6253H51.2532C51.2104 9.66113 51.1675 9.70401 51.1675 9.74689V25.8262C51.1675 25.8691 51.2104 25.9119 51.2532 25.9119H53.5687C53.6115 25.9119 53.6544 25.8691 53.6544 25.8262V13.6059C53.6544 13.5202 53.7831 13.4773 53.8259 13.563L55.7554 19.909L55.8841 20.3378C55.8841 20.3807 55.927 20.3807 55.9698 20.3807H57.7707C57.8136 20.3807 57.8565 20.3378 57.8565 20.3378L57.9851 19.909L59.9146 13.563C59.9575 13.4773 60.0861 13.4773 60.0861 13.6059V25.8262C60.0861 25.8691 60.129 25.9119 60.1719 25.9119H62.4873C62.5302 25.9119 62.5731 25.8691 62.5731 25.8262V9.74689C62.5731 9.70401 62.5302 9.66113 62.4873 9.66113H61.1152Z",
    fill: "#FFE360"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.547 9.66113C126.504 9.66113 126.461 9.70401 126.461 9.70401L124.532 16.0071C124.489 16.0928 124.403 16.0928 124.36 16.0071L122.431 9.70401C122.431 9.66113 122.388 9.66113 122.345 9.66113H118.786C118.743 9.66113 118.7 9.70401 118.7 9.74689V25.8262C118.7 25.8691 118.743 25.9119 118.786 25.9119H121.102C121.144 25.9119 121.187 25.8691 121.187 25.8262V13.6059C121.187 13.5202 121.316 13.4773 121.359 13.563L123.288 19.909L123.417 20.3378C123.417 20.3807 123.46 20.3807 123.503 20.3807H125.304C125.347 20.3807 125.389 20.3378 125.389 20.3378L125.518 19.909L127.448 13.563C127.49 13.4773 127.619 13.4773 127.619 13.6059V25.8262C127.619 25.8691 127.662 25.9119 127.705 25.9119H130.02C130.063 25.9119 130.106 25.8691 130.106 25.8262V9.74689C130.106 9.70401 130.063 9.66113 130.02 9.66113H126.547Z",
    fill: "#FFE360"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5324 9.66113H92.2018H89.8863H85.5128C85.4699 9.66113 85.427 9.70401 85.427 9.74689V11.7622C85.427 11.805 85.4699 11.8479 85.5128 11.8479H89.7577V25.8262C89.7577 25.8691 89.8006 25.9119 89.8435 25.9119H92.1589C92.2018 25.9119 92.2446 25.8691 92.2446 25.8262V11.8479H96.4896C96.5324 11.8479 96.5753 11.805 96.5753 11.7622V9.74689C96.6182 9.70401 96.5753 9.66113 96.5324 9.66113Z",
    fill: "#FFE360"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.254 25.9123H112.355C112.397 25.9123 112.44 25.8695 112.44 25.7837L108.067 9.66153C108.067 9.61865 108.024 9.61865 107.981 9.61865H107.166H105.751H104.937C104.894 9.61865 104.851 9.66153 104.851 9.66153L100.477 25.7837C100.477 25.8266 100.52 25.9123 100.563 25.9123H102.664C102.707 25.9123 102.75 25.8695 102.75 25.8695L104.036 21.1529C104.036 21.11 104.079 21.11 104.122 21.11H108.796C108.839 21.11 108.881 21.1529 108.881 21.1529L110.168 25.8695C110.168 25.8695 110.211 25.9123 110.254 25.9123ZM104.679 18.7946L106.394 12.4915C106.437 12.4057 106.523 12.4057 106.566 12.4915L108.281 18.7946C108.281 18.8374 108.238 18.9232 108.195 18.9232H104.808C104.722 18.9232 104.679 18.8374 104.679 18.7946Z",
    fill: "#FFE360"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.357 25.9123H148.458C148.501 25.9123 148.544 25.8695 148.544 25.7837L144.17 9.66153C144.17 9.61865 144.127 9.61865 144.084 9.61865H143.27H141.855H141.04C140.997 9.61865 140.954 9.66153 140.954 9.66153L136.581 25.7837C136.581 25.8266 136.624 25.9123 136.667 25.9123H138.768C138.81 25.9123 138.853 25.8695 138.853 25.8695L140.14 21.1529C140.14 21.11 140.183 21.11 140.225 21.11H144.899C144.942 21.11 144.985 21.1529 144.985 21.1529L146.271 25.8695C146.271 25.8695 146.314 25.9123 146.357 25.9123ZM140.783 18.7946L142.498 12.4915C142.541 12.4057 142.627 12.4057 142.669 12.4915L144.385 18.7946C144.385 18.8374 144.342 18.9232 144.299 18.9232H140.912C140.826 18.9232 140.783 18.8374 140.783 18.7946Z",
    fill: "#FFE360"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0062 23.5108V18.5369C72.0062 18.494 72.0491 18.4511 72.092 18.4511H78.3093C78.3522 18.4511 78.3951 18.4083 78.3951 18.3654V16.3501C78.3951 16.3072 78.3522 16.2644 78.3093 16.2644H72.092C72.0491 16.2644 72.0062 16.2215 72.0062 16.1786V11.9337C72.0062 11.8908 72.0491 11.8479 72.092 11.8479H79.124C79.1669 11.8479 79.2097 11.805 79.2097 11.7622V9.74689C79.2097 9.70401 79.1669 9.66113 79.124 9.66113H72.0062H69.605C69.5622 9.66113 69.5193 9.70401 69.5193 9.74689V11.8479V16.3072V18.494V23.6394V25.8262C69.5193 25.8691 69.5622 25.9119 69.605 25.9119H72.0062H79.4241C79.467 25.9119 79.5099 25.8691 79.5099 25.8262V23.7252C79.5099 23.6823 79.467 23.6394 79.4241 23.6394H72.0491C72.0491 23.5965 72.0062 23.5536 72.0062 23.5108Z",
    fill: "#FFE360"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M183.447 25.7408L175.385 17.4225C175.343 17.3796 175.343 17.3367 175.385 17.2938L182.632 9.74729C182.675 9.70441 182.632 9.61865 182.589 9.61865H179.63C179.588 9.61865 179.588 9.61865 179.588 9.66153L173.413 16.0933C173.37 16.1361 173.284 16.0932 173.284 16.0504V9.79016C173.284 9.74728 173.242 9.70441 173.199 9.70441H170.84C170.798 9.70441 170.755 9.74728 170.755 9.79016V25.8695C170.755 25.9123 170.798 25.9552 170.84 25.9552H173.156C173.199 25.9552 173.242 25.9123 173.242 25.8695V18.7946C173.242 18.7088 173.327 18.6659 173.37 18.7517L180.316 25.9552L180.359 25.9981H183.318C183.447 25.9123 183.489 25.7837 183.447 25.7408Z",
    fill: "#FFE360"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2596 1L21.1956 11.4623L23.8111 5.28781L35.2596 1Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75781 1L16.7361 11.548L14.2492 5.28781L2.75781 1Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 25.2261L26.4268 30.9717L34.4878 33.2014L36.7604 25.3547L30.2 25.2261Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30005 25.3547L3.57259 33.2014L11.5908 30.9717L7.8604 25.2261L1.30005 25.3547Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.162 15.5357L8.93237 18.923L16.8648 19.2661L16.6076 10.6904L11.162 15.5357Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8983 15.5355L21.3671 10.6045L21.1956 19.2659L29.128 18.9228L26.8983 15.5355Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5908 30.9716L16.3932 28.6562L12.234 25.3975L11.5908 30.9716Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6672 28.6562L26.4267 30.9716L25.7835 25.3975L21.6672 28.6562Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4267 30.9717L21.6672 28.6562L22.0531 31.7435L22.0103 33.0727L26.4267 30.9717Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5908 30.9717L16.0501 33.0727L16.0073 31.7435L16.3932 28.6562L11.5908 30.9717Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1359 23.3396L12.1482 22.1819L14.9353 20.8955L16.1359 23.3396Z",
    fill: "black",
    stroke: "#233447",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9246 23.3396L23.0823 20.8955L25.9122 22.1819L21.9246 23.3396Z",
    fill: "black",
    stroke: "#233447",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.591 30.9717L12.277 25.2261L7.8606 25.3547L11.591 30.9717Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7837 25.2261L26.4269 30.9717L30.2001 25.3547L25.7837 25.2261Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1283 18.9229L21.1958 19.2659L21.9247 23.3393L23.0824 20.8952L25.9124 22.1816L29.1283 18.9229Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1485 22.1816L14.9356 20.8952L16.1361 23.3393L16.8651 19.2659L8.93262 18.9229L12.1485 22.1816Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93237 18.9229L12.234 25.3975L12.1482 22.1816L8.93237 18.9229Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9121 22.1816L25.7834 25.3975L29.1279 18.9229L25.9121 22.1816Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 19.2661L16.136 23.3395L17.0364 28.1848L17.2508 21.7959L16.8649 19.2661Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1955 19.2661L20.8096 21.7959L20.9811 28.1848L21.9244 23.3395L21.1955 19.2661Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9245 23.3393L20.9812 28.1846L21.6673 28.6562L25.7835 25.3975L25.9122 22.1816L21.9245 23.3393Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1482 22.1816L12.2339 25.3975L16.3931 28.6562L17.0363 28.1846L16.1359 23.3393L12.1482 22.1816Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0102 33.0727L22.0531 31.7435L21.6672 31.4433H16.3503L16.0073 31.7435L16.0501 33.0727L11.5908 30.9717L13.1344 32.258L16.3074 34.4448H21.7101L24.883 32.258L26.4267 30.9717L22.0102 33.0727Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6672 28.6562L20.9812 28.1846H17.0364L16.3932 28.6562L16.0073 31.7435L16.3503 31.4433H21.6672L22.0531 31.7435L21.6672 28.6562Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8599 12.1483L37.0605 6.35977L35.2596 1L21.6672 11.1192L26.8984 15.5357L34.2734 17.6796L35.9028 15.793L35.2167 15.2784L36.3316 14.2493L35.474 13.5633L36.5888 12.7057L35.8599 12.1483Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.35977L2.20059 12.1483L1.42878 12.7057L2.54361 13.5633L1.68605 14.2493L2.84376 15.2784L2.11483 15.793L3.7442 17.6796L11.1621 15.5357L16.3932 11.1192L2.758 1L1 6.35977Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2733 17.6796L26.8983 15.5356L29.1279 18.923L25.7834 25.3976L30.1999 25.3547H36.7602L34.2733 17.6796Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M11.162 15.5356L3.7441 17.6796L1.30005 25.3547H7.8604L12.234 25.3976L8.93236 18.923L11.162 15.5356Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1955 19.2659L21.6672 11.119L23.8111 5.2876H14.2493L16.3932 11.119L16.8648 19.2659L17.0363 21.8386V28.1845H20.9811V21.8386L21.1955 19.2659Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.428781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner7);
export default __webpack_public_path__ + "static/media/partner7.dd561812d4f66f0ef2657d5213b59019.svg";
export { ForwardRef as ReactComponent };